const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const oldNewId = () =>
  [...Array(9)].map(() => alphabet[Math.floor((Math.random() * 52))]).join('');

const newId = () =>
  Math.round(Math.random() * 100000);

export default newId;
